import type {
  WWeddingThemeView,
  WWeddingThemeCustomizationView,
  WThemeGroupFontOptionsView,
} from '@zola/svc-web-api-ts-client';

export const RECEIVE_WEDDING_THEME = 'zola/weddingtheme/receive';
export const RECEIVE_CUSTOMIZATION_VALUES = 'zola/weddingtheme/customization';
export const RECEIVE_THEME_FONTS = 'zola/theme/RECEIVE_THEME_FONTS';

type ReceiveWeddingThemeActionType = {
  type: typeof RECEIVE_WEDDING_THEME;
  payload: { weddingTheme: WWeddingThemeView };
};

type ReceiveCustomizationValuesActionType = {
  type: typeof RECEIVE_CUSTOMIZATION_VALUES;
  payload: { customization: WWeddingThemeCustomizationView };
};

type ReceiveThemeFontsActionType = {
  type: typeof RECEIVE_THEME_FONTS;
  payload: { themeFonts: WThemeGroupFontOptionsView };
};

export type WeddingThemeActionTypes =
  | ReceiveWeddingThemeActionType
  | ReceiveCustomizationValuesActionType
  | ReceiveThemeFontsActionType;
